import React from "react";
import useTimerShow from "../../../hook/useTimerShow";
import { useStyleDisplay } from "../helpers/useStyleDisplay";

export default function MedicineDisplayDateTime() {
    const classsDisplay = useStyleDisplay();
    const DateTime = useTimerShow();
    return (
        <div>
            <h3
                className={`t-text-primary mb-0 text-center text-xl-left ${classsDisplay.headTextTime}`}>{`${DateTime.days}/${DateTime.months}/${DateTime.years} ${DateTime.hours}:${DateTime.minutes}:${DateTime.seconds}`}</h3>
        </div>
    );
}
